 
(function () {
  'use strict';

  class ProductFeaturedItems extends HTMLElement {
    connectedCallback() {
      if (!this.dataset.url || this.dataset.state === 'loaded') return;

      var self = this;
      if ('IntersectionObserver' in window) {
        this._observer = new IntersectionObserver(
          function (entries) {
            if (!entries[0].isIntersecting) return;
            self._observer.disconnect();
            self._observer = null;
            self.loadRecommendations();
          },
          { rootMargin: '0px 0px 400px 0px' }
        );
        this._observer.observe(this);
      } else {
        this.loadRecommendations();
      }
    }

    disconnectedCallback() {
      if (this._observer) {
        this._observer.disconnect();
        this._observer = null;
      }
      if (this._controller) this._controller.abort();
    }

    loadRecommendations() {
      if (this.dataset.state === 'loading' || this.dataset.state === 'loaded') return;
      this.dataset.state = 'loading';

      if (this._controller) this._controller.abort();
      this._controller = new AbortController();

      var self = this;
      fetch(this.dataset.url, { signal: this._controller.signal })
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector(
            'product-featured-items[data-block-id="' + self.dataset.blockId + '"]'
          );
          var content = fresh && fresh.querySelector('[data-featured-items-content]');
          self.dataset.state = 'loaded';
          if (content) { 
            var match = /[?&]product_id=(\d+)/.exec(self.dataset.url || '');
            if (match) {
              content.querySelectorAll('[data-product-id="' + match[1] + '"]').forEach(function (item) {
                item.remove();
              });
            }
            if (!content.querySelector('[data-product-id]')) {
              self.handleEmpty();
              return;
            } 
            var tileTemplate = self.querySelector('template[data-current-product-tile]');
            self.innerHTML = content.outerHTML;
            var list = self.querySelector('.product-featured-items__grid');
            if (tileTemplate && list) {
              list.prepend(tileTemplate.content.cloneNode(true));
            } 
            var maxItems = parseInt(self.dataset.maxItems, 10);
            if (list && maxItems > 0) {
              var items = list.querySelectorAll('.product-featured-items__item');
              for (var i = maxItems; i < items.length; i++) {
                items[i].remove();
              }
            }
            self.hidden = false;
          } else {
            self.handleEmpty();
          }
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
          self.dataset.state = 'loaded';
          self.handleEmpty();
        });
    }
 
    handleEmpty() {
      if (window.Shopify && window.Shopify.designMode) return;
      this.hidden = true;
    }
  }

  if (!customElements.get('product-featured-items')) {
    customElements.define('product-featured-items', ProductFeaturedItems);
  }
})();
